import { Content } from "@/ui";
import { getRoute, getRouteObject } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { jobs_helper } from "@/helpers/jobs_helper";
import { blog_helper } from "@/helpers/blog_helper";
import sn from "@/snippets";

export default function CareerAdvicePage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const route = getRouteObject("careerAdvice");
  const page = simple_pages_helper.find(route.id, "id");
  const children = blog_helper.fetch();

  if (!page) {
    return { notFound: true };
  }

  return {
    props: {
      meta: { title: createTitle("Career Advice") },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Find a Job", href: getRoute("jobs") },
              { label: page.title, href: route.url },
            ],
          },
        },
        sn.header({ page }),
        sn.gridButtons({
          page,
          className: "pt-3 pt-md-4 pb-md-2 mb-4 text-center bg-light",
          disabled: true,
        }),
        sn.promoSection({
          page,
          className: "pb-4 pb-md-5 text-center",
          items: children.map(({ title, card_summary, description, card_image, url_slug, category, tags }) => ({
            title: title ?? null,
            description: card_summary || description || null,
            img: card_image ?? null,
            href: getRoute("blog", { url_slug: url_slug }),
            category: category ?? null,
            tags: tags ?? null,
          })),
          showSearchField: true,
          showCategoryFilter: true,
          showTagFilter: false,
        }),
        {
          component: "LatestJobs",
          props: {
            className: "bg-primary py-5",
            title: { path: "page.career-advice.component.LatestJobs.title", placeholder: "Latest Jobs" },
            items: jobs_helper.fetch(),
            visibleCount: 4,
            filters: true,
          },
        },
      ],
    },
  };
}
